/**
 * UI Components - Moon Moon Agency
 * Handles dropdowns, splide carousels, and loader states
 */

/*********************************************************************************************
 * 🚀 LOADER MODULE
 */
const LoaderManager = {
  // Local configuration
  config: {
    classes: {
      loading: "mm-loading",
      active: "mm-active",
    },
    selectors: {
      dropdownTrigger: "[data-dropdown-trigger]",
    },
  },

  /**
   * Add loading state to specified element
   */
  loadThis(elem) {
    if (!elem) {
      window.log("warn", "LoaderManager", "No element provided");
      return;
    }
    elem.classList.add(this.config.classes.loading);
    window.emit("global:loader-activated", { element: elem.tagName });
  },
};

/*********************************************************************************************
 * 📋 DROPDOWN MODULE
 */
const DropdownManager = {
  /**
   * Initialize dropdown behaviors
   */
  init() {
    const dropWrappers = window.getElements(
      LoaderManager.config.selectors.dropdownTrigger,
    );
    if (!dropWrappers.length) return;

    dropWrappers.forEach((item) => {
      item.addEventListener("click", function () {
        const content = this.nextElementSibling;
        // Lire scrollHeight AVANT toute modification DOM (évite mise en page synchrone forcée)
        const scrollHeight = content ? content.scrollHeight : 0;

        // Close other dropdowns
        dropWrappers.forEach((el) => {
          if (el !== this) {
            el.classList.remove(LoaderManager.config.classes.active);
            if (el.nextElementSibling) {
              el.nextElementSibling.style.maxHeight = null;
            }
          }
        });

        // Toggle current dropdown
        this.classList.toggle(LoaderManager.config.classes.active);

        if (content) {
          const isActive = this.classList.contains(
            LoaderManager.config.classes.active,
          );
          content.style.maxHeight = isActive ? `${scrollHeight}px` : null;

          window.emit("global:dropdown-toggled", {
            active: isActive,
            element: this.tagName,
          });
        }
      });
    });
  },
};

/*********************************************************************************************
 * 🎠 SLIDER MODULE (Aero Slider)
 */
const SplideManager = {
  _instances: [],
  _mediaQuery: window.matchMedia("(min-width: 991px)"),

  init() {
    this.destroyAll();

    const sliderElements = window.getElements(".aero-slider[data-auto-init]");
    if (!window.AeroSlider) {
      return;
    }
    if (!sliderElements.length) return;

    let initializedCount = 0;

    sliderElements.forEach((element) => {
      try {
        const destroyBelow = element.dataset.destroyBelow;
        if (destroyBelow) {
          let mq = window.matchMedia("(min-width: " + destroyBelow + "px)");
          if (!mq.matches) return;
          this._setupResponsiveDestroy(element, mq);
        }

        const config = {};
        if (element.dataset.sliderLoop === "true") config.loop = true;

        const instance = window.AeroSlider.createSlider(element, config);
        this._instances.push({
          element: element,
          instance: instance,
          mq: mq || null,
        });
        initializedCount++;
      } catch (error) {
        if (window.log)
          window.log("error", "SplideManager", "Init failed: " + error.message);
      }
    });

    window.emit("global:splide-initialized", {
      count: initializedCount,
      sections: [],
    });
  },

  _setupResponsiveDestroy(element, mq) {
    var handler = (e) => {
      if (!e.matches) {
        var entry = this._instances.find((i) => i.element === element);
        if (entry) {
          entry.instance.destroy();
          this._instances = this._instances.filter(
            (i) => i.element !== element,
          );
        }
      } else {
        var exists = this._instances.find((i) => i.element === element);
        if (!exists && window.AeroSlider) {
          var config = {};
          if (element.dataset.sliderLoop === "true") config.loop = true;
          var instance = window.AeroSlider.createSlider(element, config);
          this._instances.push({
            element: element,
            instance: instance,
            mq: mq,
          });
        }
      }
    };
    mq.addEventListener("change", handler);
  },

  destroyAll() {
    this._instances.forEach((entry) => {
      try {
        entry.instance.destroy();
      } catch (e) {}
    });
    this._instances = [];
  },
};

/*********************************************************************************************
 * 🎯 UI COMPONENTS MANAGER
 */
const UIComponentsManager = {
  /**
   * Initialize all UI components
   */
  init() {
    DropdownManager.init();
    SplideManager.init();
  },
};

/*********************************************************************************************
 * 🌍 GLOBAL ACCESS
 */
window.LoaderManager = LoaderManager;
window.DropdownManager = DropdownManager;
window.SplideManager = SplideManager;
window.UIComponentsManager = UIComponentsManager;

/*********************************************************************************************
 * 🔄 BACKWARD COMPATIBILITY
 */
window.mmLoadThis = (elem) => LoaderManager.loadThis(elem);
window.handleDropdown = () => DropdownManager.init();
window.mmSplide = () => SplideManager.init();

/*********************************************************************************************
 * 🎯 AUTO-INITIALIZATION
 */
document.addEventListener("DOMContentLoaded", () => {
  UIComponentsManager.init();
});
